import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/partials/image-credits.module.scss';

const propTypes = {
    credits: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    credits: null,
    className: null,
};

const ImageCredits = ({ credits, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div>
            <span className={styles.label}>Credit&nbsp;</span>
            <span className={styles.credits}>{credits}</span>
        </div>
    </div>
);

ImageCredits.propTypes = propTypes;
ImageCredits.defaultProps = defaultProps;

export default ImageCredits;
